import { render, staticRenderFns } from "./dialog-tj-yuyue.vue?vue&type=template&id=d70c254e&scoped=true"
import script from "./dialog-tj-yuyue.vue?vue&type=script&lang=js"
export * from "./dialog-tj-yuyue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70c254e",
  null
  
)

export default component.exports